import { render, staticRenderFns } from "./ReassignmentWarning.vue?vue&type=template&id=f216f226"
import script from "./ReassignmentWarning.vue?vue&type=script&lang=js"
export * from "./ReassignmentWarning.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports